// ========================================
// ENHANCED GIFT MANAGER WITH DYNAMIC SLIDER
// ========================================

// SLIDER POLLING — Global, unabhängig von der Klasse
setInterval(() => {
  const c = document.querySelector('.drawer__bar-gifts');
  if (!c) return;

  const visible = Array.from(
    c.querySelectorAll('.bar-gifts__item')
  ).filter(i => i.style.display !== 'none' && !i.hidden);

  let hasF = false;
  try { hasF = !!(typeof Flickity !== 'undefined' && Flickity.data && Flickity.data(c)); } catch(e) {}

  if (visible.length >= 2 && !hasF) {
    if (typeof Flickity === 'undefined') return;
    try {
      new Flickity(c, {
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        prevNextButtons: true,
        freeScroll: false,
        cellSelector: '.bar-gifts__item'
      });
    } catch(e) {}
  }

  if (visible.length < 2 && hasF) {
    try { Flickity.data(c).destroy(); } catch(e) {}
  }
}, 1500);


// GIFT MANAGER KLASSE
document.addEventListener('DOMContentLoaded', function() {
  
  class CartValueTrackingGiftManager {
    constructor() {
      this.container = document.querySelector('#gift-items-container');
      this.giftItems = [];
      this.lastCartValue = null;
      this.loadGiftItemData();
      this.init();
    }

    loadGiftItemData() {
      const dataElement = document.querySelector('#gift-item-data');
      if (dataElement) {
        try {
          const data = JSON.parse(dataElement.textContent);
          this.giftItems = data.giftItems;
        } catch (error) {
          this.giftItems = [];
        }
      }
    }

    async getCurrentCartValue() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        return cart.total_price;
      } catch (error) {
        return null;
      }
    }

    init() {
      this.setupGiftButtons();
      this.setupCartMonitoring();
      
      this.getCurrentCartValue().then(value => {
        this.lastCartValue = value;
      });
    }

    // ========================================
    // GIFT BUTTON FUNCTIONALITY
    // ========================================

    setupGiftButtons() {
      document.addEventListener('click', async (e) => {
        const button = e.target.closest('.bar-gifts__add-btn');
        if (!button || button.disabled) return;

        e.preventDefault();

        const variantId = button.getAttribute('data-variant-id');
        const productId = button.getAttribute('data-product-id');
        const threshold = button.getAttribute('data-threshold');
        const giftItemId = button.getAttribute('data-gift-item-id');
        
        if (!variantId) return;

        await this.addGift(variantId, productId, threshold, giftItemId, button);
      });
    }

    async addGift(variantId, productId, threshold, giftItemId, button) {      
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Hinzufügen...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_gift': 'true',
              '_gift_product_id': productId,
              '_gift_threshold': threshold,
              '_gift_item_id': giftItemId,
              '_gift_source': 'gift_item'
            }
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        button.textContent = '✓ Hinzugefügt';
        button.classList.add('success');

        this.refreshCart();

        setTimeout(() => {
          const item = button.closest('.bar-gifts__item');
          if (item) {
            item.style.display = 'none';
          }
        }, 2000);

      } catch (error) {
        button.textContent = 'Fehler';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    }

    // ========================================
    // CART MONITORING & REFRESH
    // ========================================

    refreshCart() {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer && cartDrawer._rerenderCart) {
        try {
          cartDrawer._rerenderCart({ detail: { openMiniCart: true } });
        } catch (error) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    }

    setupCartMonitoring() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            const target = mutation.target;
            if (target.classList.contains('cart-items') || 
                target.classList.contains('drawer__items') ||
                target.querySelector('.cart-item')) {
              setTimeout(() => this.checkCartValueChange(), 500);
            }
          }
        });
      });

      const cartContainers = document.querySelectorAll('.cart-items, .drawer__items, .cart, [data-cart]');
      cartContainers.forEach(container => {
        observer.observe(container, { childList: true, subtree: true });
      });

      document.addEventListener('cart:updated', () => {
        setTimeout(() => {
          this.checkCartValueChange();
        }, 500);
      });

      if (typeof Shopify !== 'undefined') {
        document.addEventListener('shopify:cart:update', () => {
          setTimeout(() => this.checkCartValueChange(), 500);
        });
      }
    }

    async checkCartValueChange() {
      const currentCartValue = await this.getCurrentCartValue();
      
      if (currentCartValue === null) return;

      if (this.lastCartValue !== null && currentCartValue < this.lastCartValue) {
        await this.checkGifts();
      }

      this.lastCartValue = currentCartValue;
    }

    // ========================================
    // GIFT REMOVAL LOGIC
    // ========================================

    async checkGifts() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        let cartValueWithoutGifts = 0;
        const giftsInCart = [];

        cart.items.forEach(function(item) {
          const isGift = item.properties && item.properties._gift === 'true';
          if (isGift) {
            giftsInCart.push(item);
          } else {
            cartValueWithoutGifts += item.final_line_price;
          }
        });

        const giftsToRemove = [];

        giftsInCart.forEach(function(item) {
          const giftItemMatch = this.findGiftItemForProduct(item.product_id);

          let threshold = 0;
          if (item.properties && item.properties._gift_threshold) {
            threshold = parseInt(item.properties._gift_threshold);
          } else if (giftItemMatch) {
            threshold = giftItemMatch.threshold;
          }

          if (threshold > 0 && cartValueWithoutGifts < threshold) {
            giftsToRemove.push(item.key);
          }
        }.bind(this));

        if (giftsToRemove.length > 0) {
          await this.removeGifts(giftsToRemove);
        }

      } catch (error) {
        console.error('Error checking gifts:', error);
      }
    } 

    findGiftItemForProduct(productId) {
      for (let giftItem of this.giftItems) {
        if (giftItem.productId == productId) {
          return giftItem;
        }
      }
      return null;
    }

    async removeGifts(itemKeys) {
      try {
        const updates = {};
        itemKeys.forEach(key => {
          updates[key] = 0;
        });

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        if (response.ok) {
          this.refreshCart();
        }

      } catch (error) {
        console.error('Error removing gifts:', error);
      }
    }
  }

  setTimeout(() => {
    new CartValueTrackingGiftManager();
  }, 100);
});
